import type { ReactNode } from 'react';

/**
 * A chart plus the one line it sometimes needs to say about itself.
 *
 * The note is not decoration — it is what keeps an omission honest. When a
 * frame drops a column because it is on a different scale, or caps a long tail,
 * the reader is told rather than left to assume they are seeing everything.
 * Silent truncation reads as "this is all the data", which is worse than no
 * chart at all.
 */

interface Props {
  note?: string;
  children: ReactNode;
}

export const Plot = ({ note, children }: Props) => (
  <div className="plot">
    <div className="plot__chart">{children}</div>
    {note && <p className="plot__note">{note}</p>}
  </div>
);
